export type ChatFilter = 'all' | 'unread' | 'open' | 'done' | 'not_cancelled' | 'archived'

const FILTERS: { key: ChatFilter; label: string }[] = [
  { key: 'not_cancelled', label: 'Nicht storniert' },
  { key: 'all', label: 'Alle' },
  { key: 'unread', label: 'Ungelesen' },
  { key: 'open', label: 'Offen' },
  { key: 'done', label: 'Erledigt' },
  { key: 'archived', label: 'Archiv' },
]

interface ChatFilterPillsProps {
  filter: ChatFilter
  onChange: (filter: ChatFilter) => void
}

export function ChatFilterPills({ filter, onChange }: ChatFilterPillsProps) {
  return (
    <div className="px-3 py-2 flex gap-1.5 border-b border-gray-100 flex-wrap">
      {FILTERS.map(f => (
        <button
          key={f.key}
          onClick={() => onChange(f.key)}
          className={`px-2.5 py-1 text-xs rounded-full transition-colors ${
            filter === f.key
              ? 'bg-blue-500 text-white font-medium'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {f.label}
        </button>
      ))}
    </div>
  )
}
